import React from 'react';

import { ButtonTypes, LinkButton, StandardButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';

import { Piwik, SiteCoreDictionary } from '../types';

import './Footer.scss';

interface FooterProps {
    submit: () => void;
    cancel: () => void;
    loading: boolean;
    showReceipt: boolean;
    showBlockError: boolean;
    wishToOrderNewCard: boolean;
    cardShouldBeRenewed: boolean;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Footer = ({
    submit,
    cancel,
    loading,
    showReceipt,
    showBlockError,
    cardShouldBeRenewed,
    dictionary,
    wishToOrderNewCard,
    piwik,
}: FooterProps) => {
    const { goBackText, blockAreYouSureReorder, blockAreYouSureBlock, goBackToCards, formCancel } = dictionary;

    if (showBlockError) {
        return (
            <div className="footer-button-column">
                <StandardButton
                    data-track-id={piwik?.blockCardForm?.hardBlockCardSuccessOk?.dataTrackId}
                    data-track-linkname={piwik?.blockCardForm?.hardBlockCardSuccessOk?.dataTrackLinkname}
                    id={piwik?.blockCardForm?.hardBlockCardSuccessOk?.dataTrackId}
                    onClick={() => cancel()}
                >
                    {goBackText}
                </StandardButton>
            </div>
        );
    }

    if (showReceipt) {
        return (
            <div className="footer-button-row">
                <StandardButton
                    data-track-id={piwik?.orderNewCardForm?.orderCardReceiptOk?.dataTrackId}
                    data-track-linkname={piwik?.orderNewCardForm?.orderCardReceiptOk?.dataTrackLinkname}
                    id={piwik?.orderNewCardForm?.orderCardReceiptOk?.dataTrackId}
                    onClick={() => cancel()}
                >
                    {goBackToCards}
                </StandardButton>
            </div>
        );
    }

    return (
        <div className="footer-button-row">
            {!loading && (
                <LinkButton
                    data-track-id={piwik?.blockCardForm?.hardBlockCardCancel?.dataTrackId}
                    data-track-linkname={piwik?.blockCardForm?.hardBlockCardCancel?.dataTrackLinkname}
                    id={piwik?.blockCardForm?.hardBlockCardCancel?.dataTrackId}
                    onClick={() => cancel()}
                >
                    {formCancel}
                </LinkButton>
            )}
            <ButtonWithSpinner
                buttonType={ButtonTypes.STANDARD_POSITIVE}
                data-track-id={piwik?.blockCardForm?.hardBlockCardConfirm?.dataTrackId}
                data-track-linkname={piwik?.blockCardForm?.hardBlockCardConfirm?.dataTrackLinkname}
                id={piwik?.blockCardForm?.hardBlockCardConfirm?.dataTrackId}
                onClick={() => submit()}
                showSpinner={loading}
            >
                {cardShouldBeRenewed || wishToOrderNewCard ? blockAreYouSureReorder : blockAreYouSureBlock}
            </ButtonWithSpinner>
        </div>
    );
};

export default Footer;
